import React from "react";

export default function PolicyVersionTable({
  versions = []
}) {

  if (versions.length === 0) {

    return (
      <div className="policy-empty">
        No versions found
      </div>
    );
  }

  return (

   <div className="policy-table-wrapper">

  <table className="policy-table">

      <thead>

        <tr>

          <th>Version</th>

          <th>Status</th>

          <th>Effect</th>

          <th>Priority</th>

          <th>Created</th>

          <th>Updated</th>

        </tr>

      </thead>

      <tbody>

        {versions.map(version => (

          <tr
            key={`${version.policyId}-${version.version}`}
          >

            <td>

              v{version.version}

            </td>

            <td>

            <span
                className={`status-badge ${version.status.toLowerCase()}`}
            >
                {version.status}
            </span>

            </td>

            <td>

              {version.effect}

            </td>

            <td>

              {version.priority}

            </td>

            <td>

              {new Date(
                version.createdAt
              ).toLocaleString()}

            </td>

            <td>

              {new Date(
                version.updatedAt
              ).toLocaleString()}

            </td>

          </tr>

        ))}

      </tbody>

    </table>
</div>
  );
}